/// <reference path="wpt.ts" />
/// <reference path="navigationDetail.ts" />
/// <reference path="navigationHome.ts" />
/// <reference path="navigationLogon.ts" />
/// <reference path="navigationMenu.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    /**
     * Namespace for navigation logic.
     */
    let Navigation;
    (function (Navigation) {
        Navigation.HOME_VIEW_NAME = "Home";
        Navigation.LOGON_VIEW_NAME = "Logon";
        Navigation.DISABLED_CLASS = 'wpt-button--disabled';
        Navigation.REQUIRED_CLASS = 'wpt-input__input--failed';
        const LOG_CATEGORY = "WPT.Navigation";
        /**
         * BaseClass (Interface) for MenuNavigationHandler.
         */
        class MenuNavigationHandlerBaseClass {
            constructor(core, navigation) {
                this.HomeButton = null;
                this._log = null;
                this._core = core;
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("MenuNavigationHandlerBaseClass::constructor");
                this._nav = navigation;
            }
            /**
             * Present navigation elements.
             */
            startNavigation() {
                throw new TypeError("Must override method startNavigation(): void");
            }
            updateApplications(switchToLogoffApplication = false, switchToMappedApplication = false) {
                throw new TypeError("Must override method updateApplications(switchTargetApplication: boolean = false, switchToMappedApplication: boolean = false): boolean");
            }
            startLogonView() {
                throw new TypeError("Must override method displayLogonView(): void");
            }
            startApplicationView() {
                throw new TypeError("Must override method displayApplicationView(): void");
            }
            showBottomHourGlass() {
                throw new TypeError("Must override method showBottomHourGlass(): void");
            }
            hideBottomHourGlass() {
                throw new TypeError("Must override method hideBottomHourGlass(): void");
            }
            windowResized() {
                throw new TypeError("Must override method windowResized(): void");
            }
        }
        Navigation.MenuNavigationHandlerBaseClass = MenuNavigationHandlerBaseClass;
        /**
         * BaseClass (Interface) for LogonNavigationHandler.
         */
        class LogonNavigationHandlerBaseClass {
            constructor(core, navigation) {
                this._log = null;
                this._core = core;
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("LogonNavigationHandlerBaseClass::constructor");
                this._nav = navigation;
            }
            startNavigation() {
                throw new TypeError("Must override method startNavigation(): void");
            }
            presentLogonModal() {
                throw new TypeError("Must override method presentLogonModal(): void");
            }
            presentForgotPwModal() {
                throw new TypeError("Must override method presentForgotPwModal(): void");
            }
            submittedCreateAccount() {
                throw new TypeError("Must override method submittedCreateAccount(): void");
            }
        }
        Navigation.LogonNavigationHandlerBaseClass = LogonNavigationHandlerBaseClass;
        /**
         * BaseClass (Interface) for HomeNavigationHandler.
         */
        class HomeNavigationHandlerBaseClass {
            constructor(core, navigation) {
                this.HomeView = null;
                this._log = null;
                this._core = core;
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("HomeNavigationHandlerBaseClass::constructor");
                this._nav = navigation;
            }
            startNavigation() {
                throw new TypeError("Must override method startNavigation(): void");
            }
            resetNavigation() {
                throw new TypeError("Must override method resetNavigation(): void");
            }
        }
        Navigation.HomeNavigationHandlerBaseClass = HomeNavigationHandlerBaseClass;
        /**
         * Class holding navigation logic. Depends on WPT "modules": Loader, Locale, Config, Helper.
         */
        class NavigationManager {
            constructor(core) {
                this.MainPage = null;
                this._log = null;
                /** NavigationHandler for Menu */
                this.Menu = null;
                /** NavigationHandler for Logon */
                this.Logon = null;
                /** NavigationHandler for Home */
                this.Home = null;
                /** NavigationHandler for Detail Views */
                this.Details = null;
                /**
                 * Initialises navigation.
                 */
                this.init = () => {
                    this._log.info("NavigationManager.init()");
                    this.MainPage = document.getElementById('mainPage');
                    let appConfig = this._core.Config.getApplicationConfig();
                    let menuClass = null;
                    if (appConfig.hasOwnProperty('Layout') && appConfig.Layout.hasOwnProperty('MenuNavigationHandler')) {
                        menuClass = appConfig.Layout.MenuNavigationHandler;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using MenuNavigationHandler: " + menuClass);
                        }
                    }
                    let MenuNavHandler = null;
                    try {
                        if (menuClass != null) {
                            MenuNavHandler = this._core.Functions.stringToFunction(menuClass);
                        }
                    }
                    catch (ex) {
                        console.warn("failed to get menu navigation handler '" + menuClass + "': " + ex.message);
                    }
                    if (MenuNavHandler != null) {
                        this.Menu = new MenuNavHandler(this._core, this);
                    }
                    else {
                        this.Menu = new Navigation.MenuNavigationHandler(this._core, this);
                    }
                    let logonClass = null;
                    if (appConfig.hasOwnProperty('Layout') && appConfig.Layout.hasOwnProperty('LogonNavigationHandler')) {
                        logonClass = appConfig.Layout.LogonNavigationHandler;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using LogonNavigationHandler: " + logonClass);
                        }
                    }
                    let LogonNavHandler = null;
                    try {
                        if (logonClass != null) {
                            LogonNavHandler = this._core.Functions.stringToFunction(logonClass);
                        }
                    }
                    catch (ex) {
                        console.warn("failed to get logon navigation handler '" + logonClass + "': " + ex.message);
                    }
                    if (LogonNavHandler != null) {
                        this.Logon = new LogonNavHandler(this._core, this);
                    }
                    else {
                        this.Logon = new Navigation.LogonNavigationHandler(this._core, this);
                    }
                    let homeClass = null;
                    if (appConfig.hasOwnProperty('Layout') && appConfig.Layout.hasOwnProperty('HomeNavigationHandler')) {
                        homeClass = appConfig.Layout.HomeNavigationHandler;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using HomeNavigationHandler: " + homeClass);
                        }
                    }
                    let HomeNavHandler = null;
                    try {
                        if (homeClass != null) {
                            HomeNavHandler = this._core.Functions.stringToFunction(homeClass);
                        }
                    }
                    catch (ex) {
                        console.warn("failed to get home navigation handler '" + homeClass + "': " + ex.message);
                    }
                    if (HomeNavHandler != null) {
                        this.Home = new HomeNavHandler(this._core, this);
                    }
                    else {
                        this.Home = new Navigation.HomeNavigationHandler(this._core, this);
                    }
                    // I don't think we're ever actually going to need to change this, so for now at least I'm hardcoding it - MCS
                    this.Details = new Navigation.DetailNavigationHandler(this._core, this);
                    this._windowResizeCalculations();
                    window.addEventListener('resize', this._windowResizeCalculations);
                    this.Menu.startNavigation();
                };
                this._windowResizeCalculations = () => {
                    this._log.info("NavigationManager._windowResizeCalculations()");
                    this._calcPagePadding();
                    this.Menu.windowResized();
                };
                this._calcPagePadding = () => {
                    this._log.info("NavigationManager._calcPagePadding()");
                    let maxWidth = -1;
                    let appConfig = this._core.Config.getApplicationConfig();
                    if (appConfig.hasOwnProperty('PageMaxWidth') && appConfig.PageMaxWidth > 0) {
                        maxWidth = appConfig.PageMaxWidth;
                    }
                    if (maxWidth < 0) {
                        let mainConfig = this._core.Config.getMainConfig();
                        if (mainConfig.hasOwnProperty('PageMaxWidth') && mainConfig.PageMaxWidth > 0) {
                            maxWidth = mainConfig.PageMaxWidth;
                        }
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("page max width: " + maxWidth);
                    }
                    let pagePadding = 0;
                    if (maxWidth > 0) {
                        let width = window.innerWidth;
                        if (maxWidth < width) {
                            pagePadding = (width - maxWidth) / 2;
                        }
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("page padding: " + pagePadding);
                    }
                    document.documentElement.style.setProperty('--wptPadding-page-calc', pagePadding + "px");
                };
                this._log = core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("NavigationManager::constructor");
                this._core = core;
                this.init();
            }
        }
        Navigation.NavigationManager = NavigationManager;
    })(Navigation = WPTNamespace.Navigation || (WPTNamespace.Navigation = {}));
})(WPTNamespace || (WPTNamespace = {}));
